/**
 * GeneralSettingsContainer - Container Component
 *
 * Container component responsible for:
 * - Zustand store connection (useStore, useActions)
 * - Delegating presentation to the pure GeneralSettings component
 *
 * This follows the Container/Presenter pattern as defined in ADR-034.
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import { useStore, useActions } from '../../hooks/useStore';
import { useStableCallback } from '../../hooks/hookUtils';
import GeneralSettings from './GeneralSettings';

export function GeneralSettingsContainer(): React.ReactElement {
  const settings = useStore(state => state.settings);
  const actions = useActions();

  const handleThemeChange = useStableCallback((value: string) => {
    actions.updateSettings({ theme: value });
  });

  const handleUnitsChange = useStableCallback((value: string) => {
    actions.updateSettings({ units: value });
  });

  return (
    <GeneralSettings
      theme={settings.theme}
      units={settings.units}
      onThemeChange={handleThemeChange}
      onUnitsChange={handleUnitsChange}
    />
  );
}

export default GeneralSettingsContainer;
